import React, { ReactElement } from 'react';
import styled from 'styled-components';

interface Props {
  label?: string | ReactElement;
  bold?: boolean;
}

const LabelValue: React.FC<React.PropsWithChildren<Props>> = ({
  label,
  bold,
  children,
  ...otherProps
}) => {
  return (
    <div {...otherProps}>
      <Label className="LabelValue-label">{label}</Label>
      <Value className="LabelValue-value" bold={bold}>
        {children}
      </Value>
    </div>
  );
};
const Label = styled.p`
  font-size: 1.4rem;
  line-height: 120%;
  color: ${({ theme }) => theme.labels.guaranteeText};
`;

const Value = styled.div<{ bold?: boolean }>`
  font-size: ${({ bold }) => (bold ? '1.8rem' : '1.6rem')};
  line-height: 120%;
  font-weight: ${({ bold }) => (bold ? '500' : '400')};
`;

export default LabelValue;
